import adminTable from "@store/adminTable/reducers";

import { setting_category } from "@Modules/Setting/configs/constants";

export default adminTable(setting_category);
